import { ProductSelection } from '@/components/products/CheckoutHandlerContext';

/**
 * The product a returning visitor had already chosen, read from `sf` on the URL they arrived on.
 *
 * Held here rather than opened as a flow of its own, because it is not a reason to interrupt
 * anyone — it is extra knowledge about the gate the page is *going* to declare. Whichever gate
 * fires picks it up, which is what stops the two from racing.
 *
 * They used to race, and the resume lost in a way that was easy to miss: it won the race but ran
 * before the session had resolved, so it read the visitor as signed out and offered the product
 * list they had just been through instead of the payment step. Waiting for the session would only
 * have handed the race to the page's own gate. Seeding removes the race rather than picking a
 * winner — and the page's gate keeps its own properties, `persistent` above all.
 *
 * Not stored in redux: it is consumed during `openSpeedyFlow`, which computes the state redux is
 * then given, so putting it there would mean writing it only to read it back one line later.
 */
let pendingResume: ProductSelection | undefined;

export const setPendingResume = (selection?: ProductSelection) => {
  pendingResume = selection;
};

/**
 * Hand it over, once.
 *
 * An account gate leaves it alone: it wants a person, not a purchase, so it has nowhere to put a
 * product and taking it would drop the choice on the floor.
 */
export const takePendingResume = () => {
  const selection = pendingResume;
  pendingResume = undefined;
  return selection;
};

export const clearPendingResume = () => {
  pendingResume = undefined;
};
